import {combineReducers} from "redux";
import {AUTH_LOGOUT} from "../actionTypes.js";

import AuthReducer from "./AuthReducer";
import cadastrosReducer from "./cadastrosReducer";
import appReducer from "./appReducer";
import academicoReducer from "./academicoReducer";
import teacherReducer from "./teacherReducer";
import userReducer from "./userReducer";
import schoolAuthReducer from "./schoolAuthReducer";
import classOfferReducer from "./classOfferReducer";
import disciplineOfferReducer from "./disciplineOfferReducer";
import financialReducer from "./financialReducer";
import installmentReducer from "./installmentReducer";

const reducers = {
    auth: AuthReducer,
    cadastros: cadastrosReducer,
    app: appReducer,
    academico: academicoReducer,
    teachers: teacherReducer,
    users: userReducer,
    schoolAuths: schoolAuthReducer,
    classOffers: classOfferReducer,
    disciplineOffers: disciplineOfferReducer,
    financial: financialReducer,
    installments: installmentReducer,
}

const allReducer = combineReducers(reducers);

const rootReducer = (state: any, action: any) => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === AUTH_LOGOUT) {
        state = undefined;
    }

    return allReducer(state, action);
};

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
